export default __webpack_public_path__ + "assets/f039f50eb594624b9fa46c48856d6de1/burger.svg";